module.exports = __webpack_public_path__ + "media/images/ico_bal-b59f7a1fdaba292a41066bac43a88ca5.png";